/**
 * ApiClient factory for the RCP portal.
 *
 * Every `/portal/*` call is dual-auth:
 *   - `x-functions-key` header (Function gate; belt-and-braces)
 *   - `Authorization: Bearer <B2C id/access token>` (identity)
 *
 * NEVER `?code=` query — the api-client package already enforces this rule.
 * `client: 'RCP-portal'` context header is sent for telemetry.
 */

import { ApiClient } from '@retail-ops/api-client';
import { ENV } from '../constants/env';
import { PORTAL_CLIENT_ID, PORTAL_VERSION } from '../constants/version';
import { getAccessToken } from './b2c';

let _client: ApiClient | null = null;

export function getApiClient(): ApiClient {
  if (!_client) {
    _client = new ApiClient({
      baseUrl: ENV.apiBaseUrl,
      functionKey: ENV.functionKey || 'dev-missing-function-key',
      version: `${PORTAL_CLIENT_ID}@${PORTAL_VERSION}`,
      getToken: async (): Promise<string | undefined> => {
        try {
          return await getAccessToken();
        } catch {
          return undefined;
        }
      },
      context: () => ({
        clientId: PORTAL_CLIENT_ID,
      }),
    });
  }
  return _client;
}

/** Test-only reset — e.g., when switching accounts. */
export function _resetApiClient(): void {
  _client = null;
}
